import {
  // eslint-disable-next-line no-restricted-imports
  Container as BeyondContainer,
  // eslint-disable-next-line no-restricted-imports
  Grid as BeyondGrid,
  styled,
} from '@zeiss/beyond-online-react';

/**
 * Beyond currently hides the `overflow` for the grid elements. This causes issues
 * in places where an absolutely positioned element is rendered within the grid.
 * For instance when an `Autocomplete` component is rendered in the grid, the options
 * do not render correctly if the remaining page content is not sufficiently tall enough.
 */

export const Grid: typeof BeyondGrid = styled(BeyondGrid)`
  overflow: initial;
`;

const InnerGrid: typeof BeyondContainer.InnerGrid = styled(
  BeyondContainer.InnerGrid,
)`
  overflow: initial;

  && {
    /** Beyond ContentContainer has different gapping than ApplicationHeader by 8px on tablet breakpoint. */
    @media (width >= 768px) and (width <= 1023px) {
      margin: 0 var(--spacing-m);
    }
  }
`;

const InnerGridCentered: typeof BeyondContainer.InnerGridCentered = styled(
  BeyondContainer.InnerGridCentered,
)`
  overflow: initial;
`;

const FormKit: typeof BeyondContainer.FormKit = styled(BeyondContainer.FormKit)`
  overflow: initial;
`;

const FullBleed: typeof BeyondContainer.FullBleed = styled(
  BeyondContainer.FullBleed,
)`
  overflow: initial;
`;

export const Container: typeof BeyondContainer = {
  FormKit,
  FullBleed,
  InnerGrid,
  InnerGridCentered,
};
